import { render, staticRenderFns } from "./TaskCountByDay.vue?vue&type=template&id=2ca0e979&lang=pug"
import script from "./TaskCountByDay.vue?vue&type=script&lang=js"
export * from "./TaskCountByDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports